import React from 'react';
import { S } from './style';
export default function InputRadio({ title, radioGroupName, isFull, optionList, refValue, onInputChange, isError, errMessage, elementRef, }) {
    return (<div ref={elementRef}>
      <S.FieldBox isFull={isFull} isError={isError}>
        <S.FieldTitle isError={isError}>{title}：</S.FieldTitle>
        <S.LayoutRadioButton isFull={isFull}>
          {optionList.map((option, i) => (<S.RadioButtonLabel key={option.value} hasBorder={i < optionList.length - 1} htmlFor={title + option.value}>
              <S.RadioButtonTitle isChecked={option.value === refValue}>
                {option.title}
              </S.RadioButtonTitle>
              <S.InputHidden type='radio' name={radioGroupName} id={title + option.value} value={option.value} onChange={onInputChange}/>
            </S.RadioButtonLabel>))}
        </S.LayoutRadioButton>
      </S.FieldBox>
      {isError ? <S.FeedbackErrorText>{errMessage}</S.FeedbackErrorText> : null}
    </div>);
}
